export enum StorefrontWidgetCheckoutTextSize {
  ExtraSmall = "extra_small",
  Small = "small",
  Medium = "medium",
  Large = "large",
  ExtraLarge = "extra_large",
}
